module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-drawer', {
    attrs: {
      "open": _vm.sidebar.open,
      "docked": _vm.sidebar.docked
    },
    on: {
      "close": function($event) {
        return _vm.showSidebar()
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('mu-avatar', {
    attrs: {
      "src": _vm.self.avatar,
      "size": 96
    },
    on: {
      "click": _vm.showPersonindex_x
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.self.name))])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v(_vm._s(_vm.self.explain))])])]), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "albums"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "inbox",
      "color": "#2e2c6b"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Favorites"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "grade",
      "color": "#2e2c6b"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Wallet"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "send",
      "color": "#2e2c6b"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Files"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "drafts",
      "color": "#2e2c6b"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "close"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showSidebar.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "close",
      "color": "#2e2c6b"
    },
    slot: "left"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b513bf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/sidebar.vue
// module id = 503
// module chunks = 1